module.exports = __webpack_public_path__ + "fonts/Jost-900-Black.f82fc2f.otf";